import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfService {
  private groupId;
  private user;

  setGroup(group: any) {
    this.groupId = group;
  }
  getGroup(): any {
    return this.groupId;
  }

  setUser(user: any) {
    this.user = user;
  }
  getUser(): any {
    return this.user;
  }
}
